import { render, staticRenderFns } from "./SalesAndCosts.vue?vue&type=template&id=42c4a5f6&"
import script from "./SalesAndCosts.vue?vue&type=script&lang=js&"
export * from "./SalesAndCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports